/**
 * 신고 관리 관련 Write 작업 목차
 * 
 * - updateReportStatus() - 신고 상태 업데이트
 * - deleteReport() - 신고 삭제
 * - createReport() - 신고 생성
 */

import apiClient from "@/utils/api";
import { trackActivity, ACTIVITY_TYPES } from "@/utils/activityTracker";

/**
 * 신고 상태 업데이트
 * @param {string} reportId - 신고 ID
 * @param {string} status - 새로운 상태 (pending, reviewed, resolved)
 * @returns {Promise<void>}
 */
export async function updateReportStatus(reportId, status) {
  try {
    await apiClient.patch(`/api/report/${reportId}/status`, { status });
  } catch (error) {
    console.error("신고 상태 업데이트 오류:", error);
    throw error;
  }
}

/**
 * 신고 삭제
 * @param {string} reportId - 신고 ID
 * @returns {Promise<void>}
 */
export async function deleteReport(reportId) {
  try {
    await apiClient.delete(`/api/report/${reportId}`);
  } catch (error) {
    console.error("신고 삭제 오류:", error);
    throw error;
  }
}

/**
 * 신고 생성
 * @param {Object} reportData - 신고 데이터
 * @returns {Promise<string>} 생성된 신고 ID
 */
export async function createReport(reportData) {
  try {
    const response = await apiClient.post("/api/report", reportData);
    
    // 신고 활동 기록
    trackActivity(ACTIVITY_TYPES.REPORT, {
      target: reportData.targetType, // "board", "comment" 등
      targetId: reportData.targetId,
      metadata: { reason: reportData.reason },
    });
    
    return response.data.id;
  } catch (error) {
    console.error("신고 생성 오류:", error);
    throw error;
  }
}
